import { createPhaseActions, phaseAction } from 'src/helpers/redux'
import * as MailService from 'src/services/mail'
import { IObjectFullfiledActionPayload } from 'src/store/modules/storage/objects/actions'
import { IGetMailAccounts, IPostToggleLabel } from 'src/services/mail/type'
import { IMailAccount, IThread } from './types'

export const PREFIX = 'email'
export const SAGA = `${PREFIX}/saga`

export interface IGetConnectedAccounts {
  userId?: string | number
}
export type ContactCreatedPayload = IObjectFullfiledActionPayload<{
  threadIdentifier: string
  key: string
}>
export const actions = createPhaseActions(SAGA, {
  getUserEmailsAccounts: phaseAction<IGetMailAccounts>(),
  getPartnerEmailsAccounts: phaseAction<IGetMailAccounts>(),

  getCustomLabels: phaseAction<MailService.IGetCustomLabels>(),
  getMoreCustomLabels: phaseAction<MailService.IGetCustomLabels>(),

  getThreads: phaseAction<MailService.IGetThreads>(),

  toggleLabels: phaseAction<
    Omit<IPostToggleLabel, 'threadsIds' | 'operation'> & {
      operation?: string
      threads: IThread[]
      isInternal?: boolean
      recover?: boolean
    }
  >(),

  updateLabel: phaseAction<MailService.IUpdateCustomLabel>(),
  deleteLabel: phaseAction<MailService.IDeleteCustomLabel>(),
  setNewThread: phaseAction<IThread>(),

  createCustomLabel: phaseAction<MailService.ICreateCustomLabel>(),
  changeThreadPrivateMode: phaseAction<MailService.IChangeThreadPrivateMode>(),
  getThread: phaseAction<MailService.IGetThread>(),
  sentEmail: phaseAction<MailService.ISentMessage>(),
  getAssignLink: phaseAction<MailService.IGetAssignLink>(),
  unlinkEmail: phaseAction<MailService.IUnlinkEmail>(),
  toggleMailAccountPrivacy: phaseAction<IMailAccount>(),
})

export type Actions = typeof actions
